/* eslint-disable eqeqeq */
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { getIsDesktop } from '../../../utils/Utils';
import BaseDesktopDialog from '../../../custom_views/BaseDesktopDialog';

function AboutMoneyVideoCallDialog(props) {
    const isDesktop = getIsDesktop()
    const close = () => {
        props.setShow(false)
    }
   
    const getInnerHtml = () => {
        return(
            <div style={isDesktop ? {maxWidth : '400px'} : {}} className="call_info_container relative">
                <p className="call_edit_title">Условия зачисления средств</p>
                <p className="planner_share_text">Вы получите оплату после того, как<br/>созвон состоится.</p>
                
                <div style={{marginTop : '36px'}} className="flex">
                    <div style={{margin : '0'}} onClick={close} className="call_price_continue hover">Понятно</div>
                </div>
            </div>
        )
    }
    if (isDesktop){
        if (!props.isShow){
            return(<div/>)
        } 
        return(<BaseDesktopDialog isShow={props.isShow} setShow={props.setShow} getInnerHtml={getInnerHtml}/>)
    } else {
        return (
            <BottomSheet style={{zIndex : 9999}} onDismiss={() => props.setShow(false)} open={props.isShow}>
                {getInnerHtml()}
            </BottomSheet>
        )
    }
    
}

export default AboutMoneyVideoCallDialog;
